var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.photoDialog)?_c('div',{staticClass:"photo-dialog active",attrs:{"layout":"row","layout-align":"center center"},on:{"click":function($event){_vm.photoDialog = false}}},[_c('span',{staticClass:"icontainer",attrs:{"layout":"row","layout-align":"center center"}},[_c('img',{attrs:{"src":_vm.src}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }